<template>
  <div id="app">
    <mm-loading v-model="mmLoadShow" />
    <!--主体-->
    <mm-header />
    <router-view />
    <!--更新说明-->
    <mm-dialog ref="versionDialog" type="alert" head-text="公告" :body-text="versionInfo" />
    <!--播放器-->
    <audio ref="mmPlayer"></audio>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import { getHotList } from 'api'
import { MMPLAYER_CONFIG, VERSION } from '@/config'
import MmHeader from 'components/mm-header/mm-header'
import MmLoading from 'base/mm-loading/mm-loading'
import { loadMixin } from '@/utils/mixin'
import MmDialog from 'base/mm-dialog/mm-dialog'
import { getVersion, setVersion } from '@/utils/storage'

const VERSION_INFO = `<div class="mm-dialog-text text-left">
版本号：${VERSION}（${process.env.VUE_APP_UPDATE_TIME}）<br/>
1、修复搜索音乐异常问题<br>
2、修复添加喜欢歌曲后响应延迟问题<br>
3、修复移动端暂停播放问题<br>
4、GUI优化提示信息<br>
5、提高用户友好性<br>
本站歌曲不对接任何某某音乐，歌曲全部收集于网络。<br>
本站不提供任何专业服务并且随时闭站，有问题联系我
</div>`

// 更新日志
// 2024-03-29
// 1、修复搜索音乐异常问题<br>
// 2、修复添加喜欢歌曲后响应延迟问题<br>
// 3、修复移动端暂停播放问题<br>
// 4、GUI优化提示信息<br>
// 5、提高用户友好型<br>

// 2024-02-20
// 0、由于系统故障导致部分添加歌单的歌曲播放异常现已经删除，给您带来不便请谅解！<br>
// 1、修复添加歌曲到喜欢歌单后失效问题<br>
// 2、优化添加喜欢歌曲的异常处理逻辑<br>
// 3、修复后端获取音乐逻辑<br>
// 4、提高用户友好型<br>

// 2023-12-02
// 1、修复添加歌曲到喜欢歌单后失效问题<br>
// 2、优化添加喜欢歌曲的异常处理逻辑<br>
// 3、修复后端获取音乐逻辑<br>
// 4、提高用户友好型<br>

// 2023-10-22
// 1、优化网站标题显示为正在播放歌曲名称<br>
// 2、修复播放音乐异常问题<br>
// 3、修复搜索音乐异常问题<br>
// 4、修复后端获取音乐逻辑<br>
// 5、提高用户友好性<br>

// 2023-05-26
// 1、新增取消喜欢歌曲提示<br>
// 2、新增歌曲存储至腾讯COS<br>
// 3、优化移动端取消喜欢歌曲<br>
// 4、优化歌曲加载速度<br>
// 5、修复部分音乐下载异常<br>
// 6、修复取消喜欢逻辑异常<br>

// 2023-05-25
// 1、本站歌曲不对接任何某某音乐，否则容易收到法律告知函，歌曲全部收集于网络。<br>
// 2、平台目前暂时不提供歌曲下载、不提供歌词展示。<br>
// 3、本站是在我无意间一时兴起瞎写的，仅供自己方便使用。<br>
// 4、本站不提供任何专业服务并且随时闭站，有问题联系我QQ：2410685763

// 2023-05-28
// 1、新增取消喜欢歌曲<br>
// 2、新增支持下载音乐<br>
// 3、开启未登录禁止搜索歌曲<br>
// 4、优化歌曲缓存机制<br>
// 5、修复歌曲列表显示Bug<br>
// 6、修复部分歌曲播放异常<br>
// 7、修复其他已知Bug<br>
// 8、提高用户友好性<br>
// 本站歌曲不对接任何某某音乐，歌曲全部收集于网络。<br>
// 本站不提供任何专业服务并且随时闭站，有问题联系我

// 2023-05-29
// 1、优化自动刷新歌曲列表<br>
// 2、优化下载歌曲返回逻辑<br>
// 3、修复获取歌曲md5异常<br>
// 4、修复部分音乐下载异常<br>
// 5、修复歌曲列表显示Bug<br>
// 6、修复部分已知Bug<br>
// 本站歌曲不对接任何某某音乐，歌曲全部收集于网络。<br>
// 本站不提供任何专业服务并且随时闭站，有问题联系我

// 2023-05-30
// 1、优化音乐播放失败自动下一首<br>
// 本站歌曲不对接任何某某音乐，歌曲全部收集于网络。<br>
// 本站不提供任何专业服务并且随时闭站，有问题联系我

// 2023-05-31
// 1、新增取消喜欢歌曲提示<br>
// 2、优化移动端取消喜欢歌曲<br>
// 3、修复部分音乐下载异常<br>
// 4、修复取消喜欢逻辑异常<br>
// 本站歌曲不对接任何某某音乐，歌曲全部收集于网络。<br>
// 本站不提供任何专业服务并且随时闭站，有问题联系我

// 2023-06-01
// 1、新增歌曲存储至腾讯COS<br>
// 2、优化歌曲加载速度<br>
// 3、修复部分已知Bug<br>
// 本站歌曲不对接任何某某音乐，歌曲全部收集于网络。<br>
// 本站不提供任何专业服务并且随时闭站，有问题联系我

// TO DO LIST
// 1、优化网页标题显示歌名<br>
// 2、优化个人喜欢歌单缓存机制<br>
// 3、修复部分已知Bug<br>
// 本站歌曲不对接任何某某音乐，歌曲全部收集于网络。<br>
// 本站不提供任何专业服务并且随时闭站，有问题联系我

export default {
  name: 'App',
  components: {
    MmHeader,
    MmDialog,
    MmLoading
  },
  mixins: [loadMixin],
  created() {
    // 设置版本更新信息
    this.versionInfo = VERSION_INFO
    this.mmLoadShow = true
    getHotList().then((resp) => {
      const list = resp
      this.setPlaylist({ list })
      this._hideLoad()
    })

    // 设置title
    // let OriginTitile = document.title
    // let titleTime
    // document.addEventListener('visibilitychange', function () {
    //   if (document.hidden) {
    //     document.title = '死鬼去哪里了！'
    //     clearTimeout(titleTime)
    //   } else {
    //     document.title = '(つェ⊂)咦!又好了!'
    //     titleTime = setTimeout(function () {
    //       document.title = OriginTitile
    //     }, 2000)
    //   }
    // })

    // 设置audio元素
    this.$nextTick(() => {
      this.setAudioele(this.$refs.mmPlayer)
    })

    // 首次加载完成后移除动画
    let loadDOM = document.querySelector('#appLoading')
    if (loadDOM) {
      const animationendFunc = function () {
        loadDOM.removeEventListener('animationend', animationendFunc)
        loadDOM.removeEventListener('webkitAnimationEnd', animationendFunc)
        document.body.removeChild(loadDOM)
        loadDOM = null
        const version = getVersion()
        if (version !== null) {
          setVersion(VERSION)
          if (version !== VERSION) {
            this.$refs.versionDialog.show()
          }
        } else {
          setVersion(VERSION)
          this.$refs.versionDialog.show()
        }
      }.bind(this)
      loadDOM.addEventListener('animationend', animationendFunc)
      loadDOM.addEventListener('webkitAnimationEnd', animationendFunc)
      loadDOM.classList.add('removeAnimate')
    }
  },
  methods: {
    ...mapMutations({
      setAudioele: 'SET_AUDIOELE'
    }),
    ...mapActions(['setPlaylist'])
  }
}
</script>

<style lang="less">
#app {
  position: relative;
  width: 100%;
  height: 100%;
  color: @text_color;
  font-size: @font_size_medium;

  audio {
    position: fixed;
  }
}
</style>
